<template>
  <div class="btn_area2">
    <a @click="goSolutionUrl">  <button class="k-primary k-button k-big" data-role="button" role="button" aria-disabled="false" tabindex="0">{{solNm}} 바로가기</button></a>
  </div>
</template>

<script>
  import EtnersCommonUtil from '../common/etners.common.util'
  export default {
    name : "goSolution",
    data() {
      return{

      }
    },
    props:[
      'solutionUrl','solCd','solGrup','solNm'
    ],
    methods:{
      goSolutionUrl: function () {
        EtnersCommonUtil.goSolutionUrl(this.solCd,this.solutionUrl,this.solGrup)
      }
    }
  }
</script>
<style>

</style>
